import React from 'react';
import SongCard from './SongCard';
import './PlaylistView.css';

export default function PlaylistView({ playlist, onPlay, onRemoveSong, currentSong, onSavePlaylist }) {
  if (!playlist || playlist.length === 0) {
    return (
      <div className="playlist-empty">
        <div className="empty-icon">🎵</div>
        <p>选择心情、活动或流派来生成播放列表</p>
      </div>
    );
  }

  return (
    <div className="playlist-view">
      <div className="playlist-header">
        <h3>🎶 生成的播放列表 ({playlist.length} 首歌)</h3>
        <div className="playlist-actions">
          <button className="save-btn" onClick={onSavePlaylist}>
            💾 保存播放列表
          </button>
        </div>
      </div>
      <div className="playlist-songs">
        {playlist.map(song => (
          <SongCard
            key={song.id}
            song={song}
            isPlaying={currentSong && currentSong.id === song.id}
            onPlay={onPlay}
            onRemove={onRemoveSong}
            showRemove={true}
          />
        ))}
      </div>
    </div>
  );
}
